<template>
  <div>
    <div class="choose-box">
      <el-tooltip effect="dark" placement="right">
        <ul slot="content">
          <li
            style="padding: 2px 0"
            v-for="item in value"
            :key="item.matcodeId"
            :title="item.matName"
          >
            {{ item.matName }}
          </li>
        </ul>
        <ul class="value-box">
          <li
            v-for="item in value.slice(0, 5)"
            :key="item.matcodeId"
            :title="item.matName"
          >
            {{ item.matName }}
          </li>
          <li v-if="value.length > 5" style="height: 15px; line-height: 15px">
            ...
          </li>
        </ul>
      </el-tooltip>
      <div @click="showSkuMats" class="btn">请选择</div>
    </div>
    <!-- <materialDirectory
      :dialogVisible.sync="visible"
      @selectedUserSuccess="handleTrue"
      :type="1"
    /> -->
    <dialog-multi-checkbox-group
      :defaultPitchOn="defaultPitchOn"
      :dialogVisible.sync="visible"
      @determine="determine"
      @refdata="refdata"
    >
    </dialog-multi-checkbox-group>
  </div>
</template>

<script>
// import materialDirectory from "./materialDirectory";
import dialogMultiCheckboxGroup from "./dialog-multi-checkbox-group";
export default {
  name: "chooseMaterialDirectory",
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      defaultPitchOn: []
    };
  },

  components: {
    // materialDirectory,
    dialogMultiCheckboxGroup
  },

  computed: {},

  beforeMount() {},

  mounted() {},

  methods: {
    determine(row) {
      console.log("🚀 ~ determine ~ row:", row);
      const result = row.map(
        ({ categoryCode, categoryName, categoryLevel }) => ({
          matCode: categoryCode,
          matName: categoryName,
          level: categoryLevel
        })
      );
      this.$emit("update:value", result);
    },
    refdata() {},

    showSkuMats() {
      this.visible = !this.visible;
    },
    handleTrue(row) {
      const result = row.map(({ id, name, matcateryLevel }) => ({
        matCode: id,
        matName: name,
        level: matcateryLevel
      }));
      this.$emit("update:value", result);
    }
  },

  watch: {}
};
</script>
<style lang="scss" scoped>
.choose-box {
  .value-box {
    li {
      height: 24px;
      line-height: 28px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .btn {
    color: #0089ef;
    cursor: pointer;
    line-height: 20px;
  }
}
</style>
